import CoveoAINotification from '../coveo-ai-notification/CoveoAINotification.vue';
import i18nHelper from '../../myAccount/helper/i18n-helper';
export default {
  name: 'CoveoAILoggedOut',
  components: {
    CoveoAINotification
  },
  data() {
    return {
      isCoveoExpanded: false,
      displayIcon: false,
      contentTitle: this.getLabel('coveo.ai.logged.out.panel.title'),
      contentLoginLinkTitle: this.getLabel('coveo.ai.logged.out.panel.login.link'),
      contentDescription: this.getLabel('coveo.ai.logged.out.panel.description')
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.user.isAuthenticated;
    }
  },
  methods: {
    getLabel(key, value) {
      return i18nHelper.getI18nMessage(key, value);
    },
    loginClick() {
      let href = window.location.href.split(window.location.host)[1];
      if (window.location.search && window.location.search.includes('?redirectUrl=')) {
        href = window.location.search.split('?redirectUrl=')[1];
      }
      this.$store.dispatch('user/redirectCIAMUser', href);
    },
    setDisplayIcon() {
      if (this.isAuthenticated) {
        this.displayIcon = false;
        return;
      }
      const languageCode = this.$store.state.browser.languageCode;
      const pageName = this.$store.state.page?.pageInfo?.pageName || '';
      const allowedLanguages = ['en-us'];
      const excludedPages = ['search', 'headless-search'];
      const pageNameLower = pageName.toLowerCase();
      if (excludedPages.some(page => pageNameLower.includes(page)) || !allowedLanguages.includes(languageCode)) {
        this.displayIcon = false;
        return;
      }
      this.displayIcon = true;
      if (pageNameLower.includes('home')) {
        this.isCoveoExpanded = true;
      }
    }
  },
  watch: {
    isAuthenticated() {
      this.setDisplayIcon();
    },
    displayIcon(newValue) {
      if (newValue) {
        const searchEl = document.querySelector('.cmp-mega-menu-navigation__search');
        if (searchEl) {
          searchEl.style.width = '83%';
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.setDisplayIcon();
      }, 600);
    });
  }
};